import { useLoadingOvertime, useNotification } from "@refinedev/core";
import {
  useIsFetching,
  useIsMutating,
  useQueryClient,
} from "@tanstack/react-query";
import { useEffect, useState } from "react";

export const useNetworkTimeout = (timeout = 5000) => {
  const [isTimeout, setIsTimeout] = useState(!navigator.onLine);
  const isFetching = useIsFetching();
  const isMutating = useIsMutating();
  const { open } = useNotification();
  useLoadingOvertime({
    isLoading: !!isFetching || !!isMutating,
    // isLoading: true,
    interval: timeout - 1,
    onInterval(elapsed) {
      setIsTimeout(elapsed + 2 > timeout);
    },
  });
  useEffect(() => {
    const _a = isFetching,
      _b = isMutating;
  }, [isFetching, isMutating]);

  useEffect(() => {
    // create event handler
    function handleStatusChange() {
      setIsTimeout(!navigator.onLine);
    }
    function onClickInterceptor(this, event: MouseEvent) {
      const elm = event.target as HTMLElement;
      if (!navigator.onLine) {
        const cursorStyle = elm.computedStyleMap().get("cursor").toString();
        if (cursorStyle === "pointer" || elm instanceof HTMLButtonElement) {
          open?.({
            message: "ネットワークがタイムアウトしました。",
            type: "error",
            key: "notification-timeout",
          });
        }
      }
    }

    window.addEventListener("online", handleStatusChange);
    window.addEventListener("offline", handleStatusChange);
    document.addEventListener("click", onClickInterceptor);

    return () => {
      window.removeEventListener("online", handleStatusChange);
      window.removeEventListener("offline", handleStatusChange);
      document.removeEventListener("click", onClickInterceptor);
    };
  }, []);

  useEffect(() => {
    if (isTimeout) {
      open?.({
        message: "ネットワークがタイムアウトしました。",
        type: "error",
        key: "notification-timeout",
      });
      setIsTimeout(false);
    }
  }, [isTimeout]);
  useEffect(() => {
    if (isFetching === 0 && isMutating === 0) {
      setIsTimeout(false);
    }
  }, [isFetching, isMutating]);

  return isTimeout;
};
